/* dimito-scroll-restore.js v2
   컬렉션 → 상품 → 뒤로가기 시 로드된 페이지 + 스크롤 위치 복원 */
(function () {
  var DEBUG = true;                 // 확인 끝나면 false 로 바꾸세요
  var KEY = 'dimito:collection-scroll';
  var MAX_AGE = 30 * 60 * 1000;
  var MAX_PAGES = 10;

  function log() {
    if (DEBUG && window.console) console.log.apply(console, ['[scroll-restore]'].concat([].slice.call(arguments)));
  }
  function grid() { return document.getElementById('product-grid'); }
  if (!grid()) return;

  // 컬렉션 페이지에서는 브라우저 자동 복원을 끄고 끝까지 우리가 제어한다 (auto 로 되돌리지 않음)
  try { history.scrollRestoration = 'manual'; } catch (e) {}

  /* ---------- 1. 저장 ---------- */
  var lastHandle = null;

  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest && e.target.closest('#product-grid a[href*="/products/"]');
    if (a) lastHandle = a.getAttribute('href').split('?')[0];
  }, true);

  function save() {
    var g = grid();
    if (!g) return;
    var data = {
      key: location.pathname + location.search,
      page: parseInt(g.dataset.currentPage || '1', 10),
      y: window.scrollY,
      handle: lastHandle,
      t: Date.now()
    };
    try { sessionStorage.setItem(KEY, JSON.stringify(data)); } catch (e) {}
    log('saved', data);
  }

  window.addEventListener('pagehide', save);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') save();
  });

  /* ---------- 2. 복원 ---------- */
  var state = null;
  try {
    var raw = sessionStorage.getItem(KEY);
    sessionStorage.removeItem(KEY);
    if (raw) {
      var s = JSON.parse(raw);
      if (s && s.key === location.pathname + location.search && Date.now() - s.t < MAX_AGE) state = s;
      else log('state discarded', s);
    }
  } catch (e) {}

  var nav = (performance.getEntriesByType && performance.getEntriesByType('navigation')[0]) || null;
  var back = !!(nav && nav.type === 'back_forward');
  if (!back) {
    try {
      var r = new URL(document.referrer);
      back = r.origin === location.origin && r.pathname.indexOf('/products/') !== -1;
    } catch (e) {}
  }
  log('navType =', nav && nav.type, '| back =', back, '| state =', state);
  if (!state || !back) return;

  var g = grid();
  var totalPages = parseInt(g.dataset.totalPages || '1', 10) || 1;
  var target = Math.max(1, Math.min(state.page, totalPages, MAX_PAGES));
  log('restoring to page', target, 'of', totalPages);

  // 테마 무한스크롤 옵저버를 복원이 끝날 때까지 완전히 정지
  var lm = document.querySelector('collection-loadmore');
  if (lm) {
    if (lm.observer) { try { lm.observer.disconnect(); log('observer OFF'); } catch (e) {} }
    lm.style.visibility = 'hidden';
  }

  function sectionURL(page) {
    var p = new URLSearchParams(location.search);
    p.set('section_id', g.dataset.id);
    p.set('page', String(page));
    return location.pathname + '?' + p.toString();
  }

  var jobs = [];
  for (var i = 2; i <= target; i++) {
    jobs.push(
      fetch(sectionURL(i))
        .then(function (r) { return r.ok ? r.text() : ''; })
        .catch(function () { return ''; })
    );
  }

  Promise.all(jobs).then(function (pages) {
    var added = 0;
    pages.forEach(function (html) {
      if (!html) return;
      var src = new DOMParser().parseFromString(html, 'text/html').getElementById('product-grid');
      if (src && src.children.length) {
        g.insertAdjacentHTML('beforeend', src.innerHTML);
        added++;
      }
    });
    g.dataset.currentPage = String(1 + added);
    log('appended', added, 'pages / total items =', g.children.length);

    // 사용자가 직접 스크롤하면 보정 중단
    var stop = false;
    ['wheel', 'touchstart', 'keydown'].forEach(function (ev) {
      window.addEventListener(ev, function () { stop = true; }, { once: true, passive: true });
    });

    function apply() {
      if (stop) return;
      var el = state.handle
        ? g.querySelector('a[href="' + state.handle + '"], a[href^="' + state.handle + '?"]')
        : null;
      var y;
      if (el) {
        var card = el.closest('li') || el;
        var rect = card.getBoundingClientRect();
        y = window.scrollY + rect.top - Math.max(0, (window.innerHeight - rect.height) / 2);
      } else {
        y = state.y;
      }
      window.scrollTo(0, Math.max(0, y));
    }

    // 이미지 로드로 인한 밀림을 여러 번에 걸쳐 보정
    apply();
    [50, 150, 350, 700, 1200].forEach(function (d) { setTimeout(apply, d); });

    // 보정이 끝난 뒤에야 무한스크롤 재가동
    setTimeout(function () {
      if (!lm) return;
      var cur = parseInt(g.dataset.currentPage, 10);
      var btn = lm.querySelector('.load-more_btn');
      if (btn) btn.dataset.href = location.pathname + '?page=' + (cur + 1);
      lm.style.visibility = '';
      if (cur >= totalPages) { lm.remove(); log('all pages loaded, loadmore removed'); }
      else if (lm.observer) { try { lm.observer.observe(lm); log('observer ON'); } catch (e) {} }
    }, 1400);
  });
})();